import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const { user, signOut } = useAuth();
  const location = useLocation();

  const handleLogout = () => {
    signOut();
  };

  // Check if user is admin
  const isAdmin = user?.role === 'admin';

  return (
    <header className="bg-gray-800/50 backdrop-blur-md border-b border-gray-700/30 px-4 sm:px-6 py-3 sm:py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2 sm:space-x-4 min-w-0">
          <Link to="/chat" className="text-xl sm:text-2xl font-bold text-white truncate hover:text-blue-400 transition-colors">
            ROUT TECHNICAL AI
          </Link>
          <div className="w-1 h-4 sm:h-6 bg-blue-500/50 rounded-full flex-shrink-0"></div>
          <span className="text-gray-400 text-xs sm:text-sm truncate">
            Intelligent Chat & Voice Assistant
          </span>
          
          {/* Navigation Links */}
          {user && (
            <nav className="hidden md:flex items-center space-x-4 ml-4">
              <Link
                to="/chat"
                className={`px-3 py-1 rounded-lg text-sm transition-colors ${
                  location.pathname === '/chat'
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-400 hover:text-white hover:bg-gray-700/50'
                }`}
              >
                Chat
              </Link>
              {isAdmin && (
                <Link
                  to="/admin/users"
                  className={`px-3 py-1 rounded-lg text-sm transition-colors ${
                    location.pathname === '/admin/users'
                      ? 'bg-purple-600 text-white'
                      : 'text-gray-400 hover:text-white hover:bg-gray-700/50'
                  }`}
                >
                  Users
                </Link>
              )}
            </nav>
          )}
        </div>

        <div className="flex items-center space-x-2 sm:space-x-4">
          {user && (
            <>
              <div className="text-right hidden sm:block">
                <p className="text-white text-sm font-medium truncate max-w-[120px]">{user.name}</p>
                <p className="text-gray-400 text-xs truncate max-w-[120px]">{user.email}</p>
              </div>
              {isAdmin && (
                <div className="text-right hidden sm:block">
                  <span className="bg-purple-600 text-white text-xs px-2 py-1 rounded-full font-medium">
                    Admin
                  </span>
                </div>
              )}
              {/* Mobile Navigation Dropdown */}
              <div className="md:hidden relative">
                <div className="w-7 h-7 sm:w-8 sm:h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center flex-shrink-0 cursor-pointer">
                  <span className="text-white text-xs sm:text-sm font-medium">
                    {user.name.charAt(0).toUpperCase()}
                  </span>
                </div>
                <div className="absolute right-0 mt-2 w-48 bg-gray-800 border border-gray-700 rounded-lg shadow-lg py-1 z-50 hidden group-hover:block">
                  <Link
                    to="/chat"
                    className="block px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white"
                  >
                    Chat
                  </Link>
                  {isAdmin && (
                    <Link
                      to="/admin/users"
                      className="block px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white"
                    >
                      User Management
                    </Link>
                  )}
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-red-600/20 hover:text-red-300"
                  >
                    Logout
                  </button>
                </div>
              </div>
              <button
                onClick={handleLogout}
                className="px-3 py-1.5 sm:px-4 sm:py-2 bg-red-600/20 hover:bg-red-600/30 text-red-400 hover:text-red-300 rounded-lg border border-red-600/30 transition-all duration-200 text-xs sm:text-sm font-medium"
              >
                Logout
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
